import * as React from 'react';
import { CompactPaymentWrapper, IconWrapper, TightFitWrapper, DefaultWrapper } from './styles.js';
import { Sepa } from '../Icons/components/Sepa.js';
import { PayPal } from '../Icons/components/PayPal.js';
import { Card } from '../Icons/components/Card.js';

const mapTypeToContent = ({ type ="" , identifier ="" , classNames ={}  })=>{
    const maskedIdentifier = (identifier.replace(/.(?=.{4})/g, "•").match(/(.{1,4})/g) || []).join(" ");
    let normalizedType = "";
    if (typeof type === "string") {
        normalizedType = type.toLowerCase();
    }
    switch(normalizedType){
        case "card":
            return {
                extensionClassName: classNames.cardWrapper,
                WrapperComponent: DefaultWrapper,
                IconComponent: Card,
                paymentIdentifier: maskedIdentifier
            };
        case "paypal":
            return {
                extensionClassName: classNames.payPalWrapper,
                WrapperComponent: TightFitWrapper,
                IconComponent: PayPal,
                paymentIdentifier: identifier
            };
        case "sepa":
            return {
                extensionClassName: classNames.sepaWrapper,
                WrapperComponent: TightFitWrapper,
                IconComponent: Sepa,
                paymentIdentifier: identifier
            };
        default:
            return {
                WrapperComponent: TightFitWrapper,
                icon: null,
                paymentIdentifier: identifier
            };
    }
};
const CompactPaymentDisplay = ({ className , classNames ={} , type , identifier =""  })=>{
    const { paymentIdentifier , IconComponent , WrapperComponent , extensionClassName  } = mapTypeToContent({
        type,
        identifier,
        classNames
    });
    return /*#__PURE__*/ React.createElement(CompactPaymentWrapper, {
        className: className
    }, /*#__PURE__*/ React.createElement(IconWrapper, {
        className: classNames.iconWrapper
    }, IconComponent ? /*#__PURE__*/ React.createElement(IconComponent, null) : null), /*#__PURE__*/ React.createElement(WrapperComponent, {
        className: extensionClassName
    }, paymentIdentifier));
};

export { CompactPaymentDisplay };
